/* eslint-disable */
import API from "../../helpers/API";
import {
    SET_UPLOAD_MARKSHEET_LIST, SET_APPLICATION_STAGES_VIEW, SET_ALL_SUBJECTS_LIST, SET_ALL_STAGES_LIST, SET_ADVT_DETAILS, SET_ALL_STAGES_CONFIG_LIST, SET_ALL_REUPLOAD_DOCLIST, SET_ALL_REDOWNLOAD_DOCLIST, SET_EXAM_PAPER_QUESTIONS_LIMIT, SET_EXAM_PAPER_SET, SET_EXAM_SUBJECTS_FOR_OBJECTION,
    SET_OBJECTION_ANSWER_KEY_DATA, SET_EXAM_SUBJECTS_FOR_OBJECTION_FILE, SET_OBJECTION_QUESTIONS, SET_ALL_OBJECTION_FILES_PAGE_NO_COUNTER, SET_ALL_OBJECTION_FILES_DATA, SET_OBJECTION_FILE_IMAGE, SET_EXAM_SUBJECT_LIST_FOR_OBJECTION_REPORT, SET_EXAM_SUBJECT_QUESTIONS_LIST_FOR_OBJECTION_REPORT,
    SET_OBJECTION_REPORT_DATA, SET_OBJECTION__COUNT_REPORT_DATA, SET_OBJECTION_ATTACHMENT_REPORT_APPLICATIONS, SET_SEARCH_ADMIT_CARD_LIST, SET_ADMIT_CARD_SEARCH_LIST_PAGE_NO_COUNTER, GET_ALL_CANDIDATE_INFO, SET_PROFILE_SUMMARY_INFO_DATA, SET_PROFILE_INFO_DISPLAY_DATA, SET_VENUE_DETAILS, GET_APPLICATION_LISTING, GET_TYPE_OF_ARTICLES,
    SET_APPROVED_VENUE_DETAILS_FOR_ADMIT_CARDS_NOTIFICATION_SECTION, GET_EXAM_STAFF_ERROR_LIST_FILE, SET_SCHEDULE_TYPE_LIST, SET_INTERVIEW_PT_LETTER_DROPDOWN_VALUES, SET_LOOKUP_OPTIONS_DATA, GET_INTERVIEW_SCHEDULE_LIST, SET_INTERVIEW_REPORT_DATA, SET_CANDIDATE_LIST, SET_APPLICATION_DETAILS_FOR_APPLICATION_PROFILE_REPORT, GET_NAME_OF_INDEXING_BODIES
} from "../../common/constants/ActionTypes";
import {
    UPLOADMARKSHEET, MARKSHEETTEMPLATE, GET_ALL_STAGES_LIST, GET_ADVERTISEMENT_DETAILS_BY_ID, MANAGE_STAGE_CONFIG, DOWNLOAD_RETOTALING_REQUEST, GET_ALL_SUBJECTS_BY_PCT_ID, UPDATE_ADVERTISEMENT_RETOTALING, UPLOAD_RETOTALING_RESULT_LIST, GET_ALL_STAGES_CONFIG_BY_ADV_ID, ADD_UPDATE_STAGE_CONFIG, DOWNLOAD_MUSTER_REPORT,
    UPDATE_ADVERTISEMENT_FEE_CONFIG, CANDIDATELISTTEMPLATE, UPLOAD_CANDIDATE_LIST, GET_REUPLOAD_DOCLIST_BY_ADVTID, GET_REDOWNLOAD_DOCLIST_BY_ADVTID, GET_EXAM_PAPER_SET_OR_EXAM_PAPER_QUESTIONS_LIMIT, ADD_OBJECTION, MANAGE_OBJECTION_STAGE, GET_EXAM_SUBJECT_FOR_OBJECTION, UPLOAD_OBJECTION_FILE, DOWNLOAD_ELIGIBLE_CANDIDATES_LIST_FILE,
    MANAGE_OBJECTION_ANSWER_KEY_DATA, DOWNLOAD_OBJECTION_ANSWER_KEY_DATA_CSV_FILE, GET_OBJECTION_ANSWER_KEY_DATA, GET_EXAM_SUBJECT_FOR_OBJECTION_FILE, GET_OBJECTION_QUESTIONS, ADD_OBJECTION_FILE, GET_ALL_OBJECTION_FILE, MANAGE_OBJECTION_FILE, GET_OBJECTION_FILE_IMAGE, GET_OBJECTION_REPORT, GET_ELIGIBLE_CANDIDATES_SAMPLE_FILE, UPLOAD_ELIGIBLE_CANDIDATES_FILE,
    GET_OBJECTION_COUNT_REPORT, GET_OBJECTION_ATTACHMENT_REPORT_APPLICATIONS, GET_OBJECTION_ATTACHMENT_REPORT_REFERENCE_DOCUMENT, DELETE_CENTER_WISE_ADMIT_CARD_LIST, GET_SEARCH_ADMIT_CARD_LIST, GETADMITCARD, GET_PROFILES_SUMMARY_DATA, GET_PROFILE_CREATION_DRAFT_DATA, GET_VENU_DETAILS, MANAGE_ADMIT_CARD_SEARCH_LIST_DATA, GET_APPLICATION_LISTING_API, SET_SEND_NOTIFICATION,
    GET_APPROVED_VENU_DETAILS_FOR_ADMIT_CARDS_NOTIFICATION_SECTION, UPLOAD_EXAM_STAFF_DATA, DOWNLOAD_EXAM_STAFF_SAMPLE_FILE, GET_VENUE_STAFF_INFO, DOWNLOAD_INTERVIEW_PT_LETTER_SAMPLE_FILE, UPLOAD_INTERVIEW_PT_LETTER_CSV_FILE, DOWNLOAD_UPLOADED_INTERVIEW_PT_LETTER_FILE, GET_INTERVIEW_PT_LETTER_DROPDOWN_VALUES, GET_LOOKUP_OPTIONS_DATA, INTERVIEW_SCHEDULE_API_ENDPOINT, LOOKUP_OPTION, GET_APPLICATION_DETAILS_FOR_APPLICATION_PROFILE_REPORT
} from "../../common/constants/endpoints";
import { toastr } from 'react-redux-toastr';
import FileDownload from "js-file-download";
import applicationStagesLabels from "../labels/applicationstages_en.json";
import { generateObjectionCountPDFWithoutPayment, generateObjectionCountPDFWithPayment, generatePdf, generateMusterReportPdf } from "../components/CommonPdf";
import axios from "axios";
import { hideLoader, showLoader } from "../../common/actions/commonActions";
import { examStaffDataJsonToCsv, examStaffDataDownloadFile } from '../../helpers/LookupOptionHelper';
import dayjs from 'dayjs';

export const showApplicationStagesView = (flag) => {
    return async (dispatch) => {
        dispatch({
            payload: flag,
            type: SET_APPLICATION_STAGES_VIEW
        })
    }
};
export const marksheetTemlateDownload = () => {
    return async () => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        const token = session.jwtResponse && session.jwtResponse.token;

        let response;
        try {
            response = await API.get(MARKSHEETTEMPLATE,
                {
                    headers: { 'Authorization': `Bearer ${token}` },
                    responseType: 'blob',
                }
            );
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                JSON.parse(await error.response.data.text()).message : error.message
            toastr.error(errorMessage);
            return;
        }

        FileDownload(response.data, `MarksheetTemplate.csv`);
    }
};
export const documentTemlateDownload = (advtId) => {
    return async () => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        const token = session.jwtResponse && session.jwtResponse.token;

        let response;
        try {
            response = await API.get(CANDIDATELISTTEMPLATE + `?advid=${advtId}`,
                {
                    headers: { 'Authorization': `Bearer ${token}` },
                    responseType: 'blob',
                }
            );
            if (response != null) {
                FileDownload(response.data, `candidateListTemplate.csv`);
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                JSON.parse(await error.response.data.text()).message : error.message
            toastr.error(errorMessage);
            return;
        }


    }
};
export const uploadMarksheetList = (data) => {
    const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
    let token = session.jwtResponse && session.jwtResponse.token
    let formData = new FormData();
    if (data.file) {
        formData.append('file', data.file);
    }
    if (data.action == "upload") {
        formData.append('showOnlySummary', true);
    }
    if (data.action == "save") {
        formData.append('showOnlySummary', false);
    }
    let response;
    let header = {
        'Authorization': `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
        "Accept": "application/json",
        "type": "formData",
    }
    return async (dispatch) => {
        try {
            response = await API.post(UPLOADMARKSHEET, formData, {
                headers: header
            });
            dispatch({
                type: SET_UPLOAD_MARKSHEET_LIST,
                payload: response.data,
            });
            if (data.action == "upload") {
                toastr.success(applicationStagesLabels.FILE_UPLOADED_SUCCESSFULY);
            }
            if (data.action == "save") {
                toastr.success(applicationStagesLabels.FILE_SAVED_SUCCESSFULLY);
                dispatch(resetUploadMarksheetData())
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};
export const getAllStagesList = () => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        const token = session.jwtResponse && session.jwtResponse.token;

        let response;
        try {
            response = await API.get(GET_ALL_STAGES_LIST,
                {
                    headers: { 'Authorization': `Bearer ${token}` },
                }
            );

            if (response != null) {
                dispatch({
                    type: SET_ALL_STAGES_LIST,
                    payload: response.data,
                });
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message;
            toastr.error(errorMessage);
            return;
        }

    }
};
export const getAdvertisementDetailsByAdvertisementId = (id) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        const token = session.jwtResponse && session.jwtResponse.token;

        let response;
        try {
            response = await API.get(GET_ADVERTISEMENT_DETAILS_BY_ID + `/${id}`,
                {
                    headers: { 'Authorization': `Bearer ${token}` },
                }
            );
            if (response != null) {
                dispatch({
                    type: SET_ADVT_DETAILS,
                    payload: response.data,
                });
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message;
            toastr.error(errorMessage);
            return;
        }

    }
};


export const updateadvertisementPostsData = (advtId, reqdata) => {

    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.post(UPDATE_ADVERTISEMENT_RETOTALING, reqdata, {
                headers: { Authorization: `Bearer ${token}` },
            });

            let successMessage = "Retotaling Data save successfully";
            toastr.success(successMessage);
            dispatch(getAdvertisementDetailsByAdvertisementId(advtId));
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const retotalingRequestDownload = (advtId, postId = '') => {
    return async () => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        const token = session.jwtResponse && session.jwtResponse.token;

        let response;
        try {
            if (postId != '') {
                response = await API.get(DOWNLOAD_RETOTALING_REQUEST + `/${advtId}` + `/${postId}`,
                    {
                        headers: { 'Authorization': `Bearer ${token}` },
                        responseType: 'blob',
                    }
                );
            }
            else {
                response = await API.get(DOWNLOAD_RETOTALING_REQUEST + `/${advtId}`,
                    {
                        headers: { 'Authorization': `Bearer ${token}` },
                        responseType: 'blob',
                    }
                );
            }

        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                JSON.parse(await error.response.data.text()).message : error.message
            toastr.error(errorMessage);
            return;
        }

        FileDownload(response.data, `RetotalingRequest_` + advtId + `_` + postId + `.csv`);
    }
};

export const uploadRetotalingResultList = (advtId, data) => {
    const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
    let token = session.jwtResponse && session.jwtResponse.token
    let formData = new FormData();
    if (data.file) {
        formData.append('file', data.file);
    }
    if (data.action == "upload") {
        formData.append('showOnlySummary', true);
    }
    if (data.action == "save") {
        formData.append('showOnlySummary', false);
    }
    let response;
    let header = {
        'Authorization': `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
        "Accept": "application/json",
        "type": "formData",
    }
    return async (dispatch) => {
        try {
            response = await API.post(UPLOAD_RETOTALING_RESULT_LIST, formData, {
                headers: header
            });
            dispatch({
                type: SET_UPLOAD_MARKSHEET_LIST,
                payload: response.data,
            });
            if (data.action == "upload") {
                toastr.success(applicationStagesLabels.FILE_UPLOADED_SUCCESSFULY);
            }
            if (data.action == "save") {
                toastr.success(applicationStagesLabels.FILE_SAVED_SUCCESSFULLY);
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};
export const uploadCandidateList = (advtId, data) => {
    const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
    let token = session.jwtResponse && session.jwtResponse.token
    let formData = new FormData();
    if (data.file) {
        formData.append('file', data.file);
    }
    if (data.action == "upload") {
        formData.append('showOnlySummary', true);
    }
    if (data.action == "save") {
        formData.append('showOnlySummary', false);
    }
    if (advtId) {
        formData.append('advid', advtId);
    }
    let response;
    let header = {
        'Authorization': `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
        "Accept": "application/json",
        "type": "formData",
    }
    return async (dispatch) => {
        try {
            response = await API.post(UPLOAD_CANDIDATE_LIST, formData, {
                headers: header
            });
            dispatch({
                type: SET_UPLOAD_MARKSHEET_LIST,
                payload: response.data,
            });
            if (data.action == "upload") {
                toastr.success(applicationStagesLabels.FILE_UPLOADED_SUCCESSFULY);
            }
            if (data.action == "save") {
                toastr.success(applicationStagesLabels.FILE_SAVED_SUCCESSFULLY);
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const getReUploadApplicationDocList = (pageNumber = '', rowPerPage = '', advtId) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        const token = session.jwtResponse && session.jwtResponse.token;

        let response;
        try {
            if (rowPerPage) {
                response = await API.get(GET_REUPLOAD_DOCLIST_BY_ADVTID + `/${pageNumber}` + `/${rowPerPage}` + `?advid=${advtId}`,
                    {
                        headers: { 'Authorization': `Bearer ${token}` },
                    }
                );
            }
            else {
                response = await API.get(GET_REUPLOAD_DOCLIST_BY_ADVTID + `?advid=${advtId}`,
                    {
                        headers: { 'Authorization': `Bearer ${token}` },
                    }
                );
            }

            if (response != null) {
                dispatch({
                    type: SET_ALL_REUPLOAD_DOCLIST,
                    payload: response.data,
                });
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message;
            toastr.error(errorMessage);
            return;
        }

    }
}

export const getReDownloadApplicationDocList = (pageNumber = '', rowPerPage = '', advtId) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        const token = session.jwtResponse && session.jwtResponse.token;

        let response;
        try {
            if (rowPerPage) {
                response = await API.get(GET_REUPLOAD_DOCLIST_BY_ADVTID + `/${pageNumber}` + `/${rowPerPage}` + `?advid=${advtId}`,
                    {
                        headers: { 'Authorization': `Bearer ${token}` },
                    }
                );
            }
            else {
                response = await API.get(GET_REDOWNLOAD_DOCLIST_BY_ADVTID + `?advid=${advtId}`,
                    {
                        headers: { 'Authorization': `Bearer ${token}` },
                    }
                );
            }

            if (response != null) {
                dispatch({
                    type: SET_ALL_REDOWNLOAD_DOCLIST,
                    payload: response.data,
                });
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message;
            toastr.error(errorMessage);
            return;
        }

    }
}
export const resetUploadMarksheetData = () => {
    return async function (dispatch) {
        dispatch({
            type: SET_UPLOAD_MARKSHEET_LIST,
            payload: {},
        });
    }
}

export const saveStageConfig = (advtId, requestData, resetFormFields) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.post(ADD_UPDATE_STAGE_CONFIG, requestData, {
                headers: { Authorization: `Bearer ${token}` },
            });

            let successMessage = response.data.message ? response.data.message : response.message;
            toastr.success(successMessage);
            resetFormFields();
            dispatch(getAllStageConfigByAdvId(advtId));
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
}
export const updateStageConfig = (advtId, requestData, resetFormFields) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(ADD_UPDATE_STAGE_CONFIG, requestData, {
                headers: { Authorization: `Bearer ${token}` },
            });

            let successMessage = response.data.message ? response.data.message : response.message;
            toastr.success(successMessage);
            resetFormFields();
            dispatch(getAllStageConfigByAdvId(advtId));
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
}
export const getAllStageConfigByAdvId = (advId) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        const token = session.jwtResponse && session.jwtResponse.token;

        let response;
        try {
            response = await API.get(GET_ALL_STAGES_CONFIG_BY_ADV_ID + `?id=${advId}`,
                {
                    headers: { 'Authorization': `Bearer ${token}` },
                }
            );

            if (response != null) {
                dispatch({
                    type: SET_ALL_STAGES_CONFIG_LIST,
                    payload: response.data,
                });
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message;
            toastr.error(errorMessage);
            return;
        }

    }
}
export const getSubjectsListByPostCriteriaId = (pcId = '', advId = '') => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        const token = session.jwtResponse && session.jwtResponse.token;

        let response;
        try {
            if (pcId) {
                response = await API.get(GET_ALL_SUBJECTS_BY_PCT_ID + `?pcid=${pcId}`,
                    {
                        headers: { 'Authorization': `Bearer ${token}` },
                    }
                );
            }
            else if (advId) {
                response = await API.get(GET_ALL_SUBJECTS_BY_PCT_ID + `?advid=${advId}`,
                    {
                        headers: { 'Authorization': `Bearer ${token}` },
                    }
                );
            }
            else {

            }


            if (response != null) {
                dispatch({
                    type: SET_ALL_SUBJECTS_LIST,
                    payload: response.data,
                });
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message;
            toastr.error(errorMessage);
            return;
        }

    }
}
export const manageStageConfig = (advtId, requestData) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(MANAGE_STAGE_CONFIG, requestData, {
                headers: { Authorization: `Bearer ${token}` },
            });

            let successMessage = response.data.message ? response.data.message : response.message;
            toastr.success(successMessage);
            dispatch(getAllStageConfigByAdvId(advtId));
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
}

export const updateFeeConfigData = (advtId, requestBody) => {

    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(UPDATE_ADVERTISEMENT_FEE_CONFIG, requestBody, {
                headers: { Authorization: `Bearer ${token}` },
            });

            let successMessage = response.data.message ? response.data.message : response.message;
            toastr.success(successMessage);
            dispatch(getAdvertisementDetailsByAdvertisementId(advtId));
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
}

export const resetAdvertisementDetails = () => {
    return async (dispatch) => {
        dispatch({
            type: SET_ADVT_DETAILS,
            payload: [],
        });
    }
}

export const getExamPaperDetails = (type) => {
    return async (dispatch) => {
        try {
            // eslint-disable-next-line no-useless-concat
            if (type === "exam_paper_set") {
                let response = await API.get(GET_EXAM_PAPER_SET_OR_EXAM_PAPER_QUESTIONS_LIMIT + `?module=exam_creation` + `&type=exam_paper_set`);
                if (response && response.data) {
                    dispatch({
                        payload: response.data,
                        type: SET_EXAM_PAPER_SET
                    });
                }
            } else if (type === "exam_paper_questions_limit") {
                let response = await API.get(GET_EXAM_PAPER_SET_OR_EXAM_PAPER_QUESTIONS_LIMIT + `?module=exam_creation` + `&type=exam_paper_questions_limit`);
                if (response && response.data) {
                    dispatch({
                        payload: response.data,
                        type: SET_EXAM_PAPER_QUESTIONS_LIMIT
                    });
                }
            }
        } catch (error) {
            let errorMessage = ""
            if (error.response && error.response.data) {
                errorMessage = error.response.data.message;
            } else {
                errorMessage = error.message;
            }
        }
    }
};

export const addObjectionDetails = (advtId, requestData, resetFormFields, action) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            if (action === "Add") {
                response = await API.post(ADD_OBJECTION, requestData, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
            else if (action === "Edit") {
                response = await API.patch(ADD_OBJECTION, requestData, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
            let successMessage = response.data.message ? response.data.message : response.message;
            toastr.success(successMessage);
            resetFormFields();
            dispatch(getAllStageConfigByAdvId(advtId));
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const manageObjectionStage = (advtId, requestData, resetFormFields) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(MANAGE_OBJECTION_STAGE, requestData, {
                headers: { Authorization: `Bearer ${token}` },
            });
            let successMessage = response.data.message ? response.data.message : response.message;
            toastr.success(successMessage);
            resetFormFields();
            dispatch(getAllStageConfigByAdvId(advtId));
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const getExamSubjectForObjection = (exId) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        const token = session.jwtResponse && session.jwtResponse.token;

        let response;
        try {
            response = await API.get(GET_EXAM_SUBJECT_FOR_OBJECTION + `?exid=${exId}`,
                {
                    headers: { 'Authorization': `Bearer ${token}` },
                }
            );
            if (response != null) {
                dispatch({
                    type: SET_EXAM_SUBJECTS_FOR_OBJECTION,
                    payload: response.data,
                });
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message;
            toastr.error(errorMessage);
            return;
        }

    }
};

export const uploadObjectionFile = (data) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let formData = new FormData();
        if (data.file) {
            formData.append('file', data.file);
        }
        if (data.action == "upload") {
            formData.append('showOnlySummary', true);
        }
        if (data.action == "save") {
            formData.append('showOnlySummary', false);
        }
        if (data.examId) {
            formData.append('examId', data.examId);
        }
        if (data.examSubjectId) {
            formData.append('examSubjectId', data.examSubjectId);
        }
        if (data.advtId) {
            formData.append('advtId', data.advtId);
        }
        let header = {
            'Authorization': `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
            "Accept": "application/json",
            "type": "formData",
        }
        let response;
        try {
            response = await API.post(UPLOAD_OBJECTION_FILE, formData, {
                headers: header,
            });
            let successMessage = response.data ? response.data : response.message;
            toastr.success(successMessage);
            dispatch(getObjectionAnswerKeyData(data.advtId))
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const getObjectionAnswerKeyData = (advtId) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        const token = session.jwtResponse && session.jwtResponse.token;

        let response;
        try {
            response = await API.get(GET_OBJECTION_ANSWER_KEY_DATA + `?advtId=${advtId}`,
                {
                    headers: { 'Authorization': `Bearer ${token}` },
                }
            );

            if (response != null) {
                dispatch({
                    type: SET_OBJECTION_ANSWER_KEY_DATA,
                    payload: response.data,
                });
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message;
            toastr.error(errorMessage);
            return;
        }
    }
};

export const downloadObjectionAnswerKeyData = (advtId, examSubjectId, examId, examName, examSubjectName) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        const token = session.jwtResponse && session.jwtResponse.token;

        let response;
        try {
            response = await API.get(DOWNLOAD_OBJECTION_ANSWER_KEY_DATA_CSV_FILE + `?advtId=${advtId}` + `&examSubjectId=${examSubjectId}` + `&examId=${examId}`,
                {
                    headers: { 'Authorization': `Bearer ${token}` },
                }
            );
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                JSON.parse(await error.response.data.text()).message : error.message
            toastr.error(errorMessage);
            return;
        }
        if (response && response.data) {
            const headerMappings = {
                srNo: "SrNo",
                a: "A",
                b: "B",
                c: "C",
                d: "D",
                correctAnswer: "CorrectAnswer"
            };

            const headerRow = Object.values(headerMappings).join(",");

            const csvRows = response.data.advertisementExamQuestionSetCsvDtoList.map(obj => {
                const values = Object.keys(headerMappings).map(header => obj[header]);
                return values.join(",");
            });

            const csvData = [headerRow, ...csvRows].join("\n");

            FileDownload(csvData, `${examName}-${examSubjectName}.csv`);
        }
        dispatch(getObjectionAnswerKeyData(advtId));
    }
};

export const manageObjectionAnswerKeyData = (adverId, examSubjectId) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(MANAGE_OBJECTION_ANSWER_KEY_DATA + `/${adverId}` + `/${examSubjectId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            let successMessage = response.data ? response.data : response.message;
            toastr.success(successMessage);
            dispatch(getObjectionAnswerKeyData(adverId));
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const getExamSubjectsForObjectionFile = (advid, stageid) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        const token = session.jwtResponse && session.jwtResponse.token;

        let response;
        try {
            response = await API.get(GET_EXAM_SUBJECT_FOR_OBJECTION_FILE + `?advid=${advid}` + `&stageid=${stageid}`,
                {
                    headers: { 'Authorization': `Bearer ${token}` },
                }
            );
            if (response != null) {
                dispatch({
                    type: SET_EXAM_SUBJECTS_FOR_OBJECTION_FILE,
                    payload: response.data,
                });
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const getObjectionQuestions = (advid, stageid, exsubid) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        const token = session.jwtResponse && session.jwtResponse.token;

        let response;
        try {
            response = await API.get(GET_OBJECTION_QUESTIONS + `?advid=${advid}` + `&stageid=${stageid}` + `&exsubid=${exsubid}`,
                {
                    headers: { 'Authorization': `Bearer ${token}` },
                }
            );
            if (response != null) {
                dispatch({
                    type: SET_OBJECTION_QUESTIONS,
                    payload: response.data,
                });
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const addObjectionFile = (advertismentId, examSubjectCode, questionNo, objectionFile, examSubjectId) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let formData = new FormData();

        if (advertismentId) {
            formData.append('advertismentId', advertismentId);
        }

        if (examSubjectCode) {
            formData.append('examSubjectCode', examSubjectCode);
        }

        if (questionNo) {
            formData.append('questionNo', questionNo);
        }

        if (examSubjectId) {
            formData.append('examSubjectId', examSubjectId);
        }

        if (objectionFile) {
            formData.append('objectionFile', objectionFile);
        }

        let header = {
            'Authorization': `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
            "Accept": "application/json",
            "type": "formData",
        }
        let response;
        try {
            response = await API.post(ADD_OBJECTION_FILE, formData, {
                headers: header,
            });
            let successMessage = response.data ? response.data : response.message;
            toastr.success(successMessage);
            dispatch(getAllObjectionFilesData(0, 10, advertismentId));
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const getAllObjectionFilesData = (pageNumber, rowPerPage, advid) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_ALL_OBJECTION_FILE + `/${pageNumber}` + `/${rowPerPage}` + `?advid=${advid}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (response?.data?.objectionFileList?.length > 0) {
                dispatch({
                    type: SET_ALL_OBJECTION_FILES_DATA,
                    payload: response?.data
                });
                dispatch({
                    type: SET_ALL_OBJECTION_FILES_PAGE_NO_COUNTER,
                    payload: (pageNumber * rowPerPage),
                });
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }

    };
};

export const manageObjectionFileStage = (advtId, requestData) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(MANAGE_OBJECTION_FILE, requestData, {
                headers: { Authorization: `Bearer ${token}` },
            });
            let successMessage = response.data ? response.data : response.message;
            toastr.success(successMessage);
            dispatch(getAllObjectionFilesData(0, 10, advtId));
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const getObjectionFileImage = (filename) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        const token = session.jwtResponse && session.jwtResponse.token;

        let response;
        try {
            response = await API.get(GET_OBJECTION_FILE_IMAGE + `?filename=${filename}`,
                {
                    headers: { 'Authorization': `Bearer ${token}` },
                }
            );

            if (response != null) {
                dispatch({
                    type: SET_OBJECTION_FILE_IMAGE,
                    payload: response.data,
                });
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message;
            toastr.error(errorMessage);
            return;
        }

    }
};

export const updateObjectionFile = (id, advertismentId, examSubjectCode, questionNo, objectionFile, examSubjectId) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let formData = new FormData();

        if (id) {
            formData.append('id', id);
        }

        if (advertismentId) {
            formData.append('advertismentId', advertismentId);
        }

        if (examSubjectCode) {
            formData.append('examSubjectCode', examSubjectCode);
        }

        if (questionNo) {
            formData.append('questionNo', questionNo);
        }

        if (examSubjectId) {
            formData.append('examSubjectId', examSubjectId);
        }

        if (objectionFile) {
            formData.append('objectionFile', objectionFile);
        }

        let header = {
            'Authorization': `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
            "Accept": "application/json",
            "type": "formData",
        }
        let response;
        try {
            response = await API.patch(ADD_OBJECTION_FILE, formData, {
                headers: header,
            });
            let successMessage = response.data ? response.data : response.message;
            toastr.success(successMessage);
            dispatch(getAllObjectionFilesData(0, 10, advertismentId));
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const getExamSubjectForObjectionReport = (exId) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        const token = session.jwtResponse && session.jwtResponse.token;

        let response;
        try {
            response = await API.get(GET_EXAM_SUBJECT_FOR_OBJECTION + `?exid=${exId}`,
                {
                    headers: { 'Authorization': `Bearer ${token}` },
                }
            );
            if (response != null) {
                dispatch({
                    type: SET_EXAM_SUBJECT_LIST_FOR_OBJECTION_REPORT,
                    payload: response.data,
                });
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message;
            toastr.error(errorMessage);
            return;
        }

    }
};

export const getObjectionExamSubjectQuestions = (advid, stageid, exsubid) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        const token = session.jwtResponse && session.jwtResponse.token;

        let response;
        try {
            response = await API.get(GET_OBJECTION_QUESTIONS + `?advid=${advid}` + `&stageid=${stageid}` + `&exsubid=${exsubid}`,
                {
                    headers: { 'Authorization': `Bearer ${token}` },
                }
            );
            if (response != null) {
                dispatch({
                    type: SET_EXAM_SUBJECT_QUESTIONS_LIST_FOR_OBJECTION_REPORT,
                    payload: response.data,
                });
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const getObjectionReportData = (advid, exid, exsubid, queno) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        const token = session.jwtResponse && session.jwtResponse.token;

        let response;
        try {
            response = await API.get(GET_OBJECTION_REPORT + `?advid=${advid}` + `&exid=${exid}` + `&exsubid=${exsubid}` + `&queno=${queno}`,
                {
                    headers: { 'Authorization': `Bearer ${token}` },
                }
            );
            if (response != null) {
                dispatch({
                    type: SET_OBJECTION_REPORT_DATA,
                    payload: response.data,
                });
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const getObjectionCountReportData = (objectionCountFlg, exid, esubid, advid, viewFlg) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        const token = session.jwtResponse && session.jwtResponse.token;
        let flg = '';
        if (objectionCountFlg == 0) {
            flg = true;
        } else if (objectionCountFlg == 1) {
            flg = false;
        };

        let response;
        try {
            response = await API.get(GET_OBJECTION_COUNT_REPORT + `/${flg}` + `?exid=${exid}` + `&esubid=${esubid}` + `&advid=${advid}`,
                {
                    headers: { 'Authorization': `Bearer ${token}` },
                }
            );
            if (response != null) {
                dispatch({
                    type: SET_OBJECTION__COUNT_REPORT_DATA,
                    payload: response.data,
                });
            };

            if ((objectionCountFlg == 0) && (viewFlg === "download") && (response != null)) {
                generateObjectionCountPDFWithPayment(response.data)
            } else if ((objectionCountFlg == 1) && (viewFlg === "download") && (response != null)) {
                generateObjectionCountPDFWithoutPayment(response.data)
            };

        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const getObjectionAttachmentReportApplications = (advid, exid, esubid, queno, stageid) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        const token = session.jwtResponse && session.jwtResponse.token;

        let response;
        try {
            response = await API.get(GET_OBJECTION_ATTACHMENT_REPORT_APPLICATIONS + `?advid=${advid}` + `&exid=${exid}` + `&esubid=${esubid}` + `&queno=${queno}`,
                {
                    headers: { 'Authorization': `Bearer ${token}` },
                }
            );
            if (response != null) {
                dispatch({
                    type: SET_OBJECTION_ATTACHMENT_REPORT_APPLICATIONS,
                    payload: response.data,
                });
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const getObjectionAttachmentReportsReferenceDocument = (advid, exid, esubid, queno) => {
    return async (dispatch) => {
        let response;
        try {
            const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
            const token = session.jwtResponse && session.jwtResponse.token;
            response = await axios.request({
                url: GET_OBJECTION_ATTACHMENT_REPORT_REFERENCE_DOCUMENT + `?advid=${advid}` + `&exid=${exid}` + `&esubid=${esubid}` + `&queno=${queno}`,
                method: "GET",
                responseType: "blob",
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch (error) {
            toastr.error("Document not available to download");
            return;
        }
        FileDownload(
            response.data,
            `Objection Attachment Report.zip`
        );
    }
};

export const downloadGetObjectionAttachmentReportsReferenceDocument = (advid, exid, esubid, queno, appno) => {
    return async function () {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await axios.request({
                url: GET_OBJECTION_ATTACHMENT_REPORT_REFERENCE_DOCUMENT + `/${appno}` + `?advid=${advid}` + `&exid=${exid}` + `&esubid=${esubid}` + `&queno=${queno}`,
                method: "GET",
                headers: { Authorization: `Bearer ${token}` },
            });
            let base64Data = response && response.data && response.data.objectionRequestsDto && response.data.objectionRequestsDto.objectionReqRefDoc;
            const binaryData = atob(base64Data);
            const fileData = new Blob([new Uint8Array([...binaryData].map(char => char.charCodeAt(0)))]);
            FileDownload(fileData, `${appno}_${advid}_${exid}.pdf`);
        } catch (error) {

            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
}

export const deleteCenterWiseAdmitCard = (examid, examcenterid, templateid, venueid) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        const token = session.jwtResponse && session.jwtResponse.token;

        let response;
        try {
            response = await API.delete(DELETE_CENTER_WISE_ADMIT_CARD_LIST + `?examid=${examid}` + `&examcenterid=${examcenterid}` + `&templateid=${templateid}` + `&venueid=${venueid}`,
                {
                    headers: { 'Authorization': `Bearer ${token}` },
                }
            );
            if (response) {
                let successMessage = response.data && response.data.message ? response.data.message : response.message;
                toastr.success(successMessage);
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const getSearchAdmitCardListData = (pageNumber, rowPerPage, advid, searchstring) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        const token = session.jwtResponse && session.jwtResponse.token;

        let response;
        try {
            response = await API.get(GET_SEARCH_ADMIT_CARD_LIST + `/${pageNumber}` + `/${rowPerPage}` + `?advid=${advid}` + `&searchstring=${searchstring}`,
                {
                    headers: { 'Authorization': `Bearer ${token}` },
                }
            );
            if (response != null) {
                dispatch({
                    type: SET_SEARCH_ADMIT_CARD_LIST,
                    payload: response.data,
                });
                dispatch({
                    type: SET_ADMIT_CARD_SEARCH_LIST_PAGE_NO_COUNTER,
                    payload: (pageNumber * rowPerPage),
                });
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const admitCard = (id, tempid) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        let isSuccess = true;
        try {
            if (id && tempid) {
                response = await API.get(GETADMITCARD + `?id=${id}` + `&templateid=${tempid}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            } else {
                response = await API.get(GETADMITCARD + `?id=${id}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }

            dispatch({
                type: GET_ALL_CANDIDATE_INFO,
                payload: response.data,
            });
            return response;
        } catch (error) {
            isSuccess = false;
            let errorMessage = (error.response && error.response.data) ? error.response.data.message : error.message;
            toastr.error(errorMessage);
            throw error;
        }
    };
};


export const getProfileSummaryDetails = (profileId) => {
    return async function (dispatch) {
        dispatch(showLoader());
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        if (!profileId) {
            profileId = session.profileId;
        }
        let response;
        try {
            if (profileId) {
                response = await API.get(GET_PROFILES_SUMMARY_DATA + `/${profileId}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                if (response != null) {
                    dispatch(hideLoader());
                }
                dispatch({
                    type: SET_PROFILE_SUMMARY_INFO_DATA,
                    payload: response.data,
                });
            }
            else {
                dispatch(hideLoader());
            }
        } catch (err) {
            dispatch(hideLoader());
            return;
        }
    };
};

export const getProfileInfoDisplay = (profileId) => {
    return async function (dispatch) {
        dispatch(showLoader());
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        if (!profileId) {
            profileId = session.profileId;
        }
        let response;
        try {
            response = await API.get(GET_PROFILE_CREATION_DRAFT_DATA + `/${profileId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (response != null) {
                dispatch(hideLoader());
            }
            dispatch({
                type: SET_PROFILE_INFO_DISPLAY_DATA,
                payload: response.data,
            });
        } catch (err) {
            dispatch(hideLoader());
            return;
        }

    };
};

export const getVenueDetails = (examid, examcenterid, templateid) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_VENU_DETAILS + `?examid=${examid}` + `&examcenterid=${examcenterid}` + `&templateid=${templateid}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if ((response) && (response.data) && (response.data.timeTableDtoList)) {
                dispatch({
                    type: SET_VENUE_DETAILS,
                    payload: response.data.timeTableDtoList,
                });
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const manageAdmitCardSearchListData = (applicationid, isactive, admitCardSearchData, advtId) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(MANAGE_ADMIT_CARD_SEARCH_LIST_DATA + `/${applicationid}` + `/${isactive}`, {}, {
                headers: { Authorization: `Bearer ${token}` },
            });
            let successMessage = response.data ? response.data : response.message;
            toastr.success(successMessage);
            dispatch(getSearchAdmitCardListData(0, 10, advtId, admitCardSearchData));
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const getapplicationListing = (advid, tempid, examdate, examcenterid, venueid, candidatename, applicationno, mobileno) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_APPLICATION_LISTING_API + `?advid=${advid}` + `&tempid=${tempid}` + `&examdate=${examdate}` + `&examcenterid=${examcenterid}` + `&venueid=${venueid}` + `&candidatename=${candidatename}` + `&applicationno=${applicationno}` + `&mobileno=${mobileno}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if ((response) && (response.data)) {
                dispatch({
                    type: GET_APPLICATION_LISTING,
                    payload: response.data,
                });
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const saveSMSdata = (data, adverId, templatename, tempid, examdate, examcenterid, venueid, candidatename, applicationno, mobileno) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.post(SET_SEND_NOTIFICATION + `?advid=${adverId}` + `&templatename=${templatename}` + `&tempid=${tempid}` + `&examdate=${examdate}` + `&examcenterid=${examcenterid}` + `&venueid=${venueid}` + `&candidatename=${candidatename}` + `&applicationno=${applicationno}` + `&mobileno=${mobileno}`, data, {
                headers: { Authorization: `Bearer ${token}` },
            });
            let successMessage = response.data ? response.data : response.message;
            toastr.success(successMessage);
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const getApprovedVenueDetailsAPI = (advtId, examcenterId) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        let advid = advtId ? advtId : '';
        let examcenterid = examcenterId ? examcenterId : '';
        try {
            response = await API.get(GET_APPROVED_VENU_DETAILS_FOR_ADMIT_CARDS_NOTIFICATION_SECTION + `?advid=${advid}` + `&examcenterid=${examcenterid}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if ((response) && (response.data)) {
                dispatch({
                    type: SET_APPROVED_VENUE_DETAILS_FOR_ADMIT_CARDS_NOTIFICATION_SECTION,
                    payload: response.data,
                });
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const uploadExamStaffDataAPI = (data) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let formData = new FormData();
        if (data.file) {
            formData.append('file', data.file);
        };

        if (data.advertisementId) {
            formData.append('advertisementId', data.advertisementId);
        };

        if (data.examId) {
            formData.append('examId', data.examId);
        };

        if (data.templateId) {
            formData.append('templateId', data.templateId);
        };

        if (data.examCenterId) {
            formData.append('examCenterId', data.examCenterId);
        };

        if (data.venueId) {
            formData.append('venueId', data.venueId);
        };

        if (data.date) {
            formData.append('date', data.date);
        };

        let header = {
            'Authorization': `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
            "Accept": "application/json",
            "type": "formData",
        }
        let response;
        try {
            response = await API.post(UPLOAD_EXAM_STAFF_DATA, formData, {
                headers: header,
            });

            if (response && response.data && response.data.errorInFile) {
                let errorMessage = (response.data && response.data.message) ? response.data.message : response.message;
                toastr.error(errorMessage);
                if (response && response.data && response.data.venueStaffInfoCsvDtoList && response.data.venueStaffInfoCsvDtoList.length > 0) {
                    dispatch({
                        type: GET_EXAM_STAFF_ERROR_LIST_FILE,
                        payload: response.data.venueStaffInfoCsvDtoList,
                    });
                    const errors = response.data.venueStaffInfoCsvDtoList.map((row) => ({
                        venue: row
                    }));
                    const csvData = examStaffDataJsonToCsv(errors);
                    examStaffDataDownloadFile(csvData, "Exam Staff Error File");

                }
            } else {
                let successMessage = (response.data && response.data.message) ? response.data.message : response.message;
                toastr.success(successMessage);
                dispatch(resetExamStaffErrorList());
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const resetExamStaffErrorList = () => {
    return async (dispatch) => {
        dispatch({
            type: GET_EXAM_STAFF_ERROR_LIST_FILE,
            payload: []
        })
    }
}

export const examStaffSampleFileDownload = () => {
    return async () => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        const token = session.jwtResponse && session.jwtResponse.token;

        let response;
        try {
            response = await API.get(DOWNLOAD_EXAM_STAFF_SAMPLE_FILE,
                {
                    headers: { 'Authorization': `Bearer ${token}` },
                    responseType: 'blob',
                }
            );
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                JSON.parse(await error.response.data.text()).message : error.message
            toastr.error(errorMessage);
            return;
        }
        FileDownload(response.data, `Exam Staff.csv`);
    }
};

export const getVenueStaffInfo = (advtId, examcenterId, venuId, examDate, modeId) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        let advid = advtId ? advtId : '';
        let examcenterid = examcenterId ? examcenterId : '';
        let venueid = venuId ? venuId : '';
        let date = examDate ? examDate : '';
        let modeid = modeId ? modeId : '';

        try {
            response = await API.get(GET_VENUE_STAFF_INFO + `?advid=${advid}` + `&examcenterid=${examcenterid}` + `&venueid=${venueid}` + `&date=${date}` + `&modeid=${modeid}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if ((response) && (response.data) && response.data.venueStaffInfoCsvDtoList && response.data.venueStaffInfoCsvDtoList.length > 0) {
                const errors = response.data.venueStaffInfoCsvDtoList.map((row) => ({
                    venue: row
                }));
                const csvData = examStaffDataJsonToCsv(errors);
                examStaffDataDownloadFile(csvData, "Exam Staff File");
            } else {
                toastr.error("No Data Found")
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const interviewLetterCsvFileDownload = () => {
    return async () => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        const token = session.jwtResponse && session.jwtResponse.token;

        let response;
        try {
            response = await API.get(DOWNLOAD_INTERVIEW_PT_LETTER_SAMPLE_FILE,
                {
                    headers: { 'Authorization': `Bearer ${token}` },
                    responseType: 'blob',
                }
            );
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                JSON.parse(await error.response.data.text()).message : error.message
            toastr.error(errorMessage);
            return;
        }
        FileDownload(response.data, `Interview/PT Sample File.csv`);
    }
};

export const getScheduleTypeListAPI = () => {
    return async (dispatch) => {
        try {
            let response = await API.get(GET_EXAM_PAPER_SET_OR_EXAM_PAPER_QUESTIONS_LIMIT + `?module=interview_pt` + `&type=schedule_type`);
            if (response && response.data) {
                dispatch({
                    payload: response.data,
                    type: SET_SCHEDULE_TYPE_LIST
                });
            }
        } catch (error) {
            let errorMessage = ""
            if (error.response && error.response.data) {
                errorMessage = error.response.data.message;
            } else {
                errorMessage = error.message;
            }
        }
    }
};

export const uploadInterviewPTLetterCsvAPI = (data) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let formData = new FormData();
        if (data.file) {
            formData.append('file', data.file);
        };

        if (data.advertisementId) {
            formData.append('advertisementId', data.advertisementId);
        };

        if (data.scheduleType) {
            formData.append('scheduleType', data.scheduleType);
        };

        if (data.postid) {
            formData.append('postId', data.postid);
        };

        let header = {
            'Authorization': `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
            "Accept": "application/json",
            "type": "formData",
        }
        let response;
        try {
            response = await API.post(UPLOAD_INTERVIEW_PT_LETTER_CSV_FILE, formData, {
                headers: header,
            });
            if (response && response.data && response.data.errorInFile) {
                let errorMessage = (response.data && response.data.message) ? response.data.message : response.message;
                toastr.error(errorMessage);
                if (response && response.data && response.data.interviewPtCsvDtoList && response.data.interviewPtCsvDtoList.length > 0) {
                    const errors = response.data.interviewPtCsvDtoList.map((row) => ({
                        venue: row
                    }));
                    const csvData = examStaffDataJsonToCsv(errors);
                    examStaffDataDownloadFile(csvData, "Interview/PT Error File");
                }
            } else {
                let successMessage = (response.data && response.data.message) ? response.data.message : response.message;
                toastr.success(successMessage);
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const downloadUploadedInterviewPtLetterFile = (advtId, schtypeId, postId, examcenterId, interviewDate, interviewSession, interviewPhase, interviewCommittee, venueName, interviewPtLetterReportName) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        let advid = advtId ? advtId : '';
        let schtypeid = schtypeId ? schtypeId : '';
        let postid = postId ? postId : '';
        let examcenterid = examcenterId ? examcenterId : '';
        let date = interviewDate ? interviewDate : '';
        let interviewsession = interviewSession ? interviewSession : '';
        let phase = interviewPhase ? interviewPhase : '';
        let committee = interviewCommittee ? interviewCommittee : '';

        try {
            response = await API.get(DOWNLOAD_UPLOADED_INTERVIEW_PT_LETTER_FILE + `?advid=${advid}` + `&schtypeid=${schtypeid}` + `&postid=${postid}` + `&examcenterid=${examcenterid}` + `&date=${date}` + `&session=${interviewsession}` + `&phase=${phase}` + `&committee=${committee}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if ((interviewPtLetterReportName === 'Application Recommendation') || (interviewPtLetterReportName === 'Profile Details') || (props.interviewPtLetterReportName === 'SUMMARY SHEET')) {
                if ((response) && (response.data) && response.data.interviewPtCsvDtoList && response.data.interviewPtCsvDtoList.length > 0) {
                    dispatch({
                        type: SET_CANDIDATE_LIST,
                        payload: response.data.interviewPtCsvDtoList,
                    });
                } else {
                    toastr.error("No Data Found")
                }
            } else {
                if ((response) && (response.data) && response.data.interviewPtCsvDtoList && response.data.interviewPtCsvDtoList.length > 0) {
                    const errors = response.data.interviewPtCsvDtoList.map((row) => ({
                        venue: row
                    }));
                    const csvData = examStaffDataJsonToCsv(errors);
                    examStaffDataDownloadFile(csvData, "Interview/PT File");
                } else {
                    toastr.error("No Data Found")
                }
            }

        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const getInterviewPtLetterDropdownValuesAPI = (advId, schtypeId, postId) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        const token = session.jwtResponse && session.jwtResponse.token;
        let advid = advId ? advId : '';
        let schtypeid = schtypeId ? schtypeId : '';
        let postid = postId ? postId : '';

        let response;
        try {
            response = await API.get(GET_INTERVIEW_PT_LETTER_DROPDOWN_VALUES + `?advid=${advid}` + `&schtypeid=${schtypeid}` + `&postid=${postid}`,
                {
                    headers: { 'Authorization': `Bearer ${token}` },
                }
            );

            if (response != null) {
                dispatch({
                    type: SET_INTERVIEW_PT_LETTER_DROPDOWN_VALUES,
                    payload: response.data,
                });
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message;
            toastr.error(errorMessage);
            return;
        }

    }
};

export const getInterviewPhaseDetailsAPI = () => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            // response = await API.get(GET_LOOKUP_OPTIONS_DATA + `?module=interview_pt&type=phase`, {
            //     headers: { Authorization: `Bearer ${token}` },
            // });
            response = await API.get(LOOKUP_OPTION + `?module=interview_pt`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_LOOKUP_OPTIONS_DATA,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
};

export const interviewScheduleAPI = (advtId, requestData) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.post(INTERVIEW_SCHEDULE_API_ENDPOINT, requestData, {
                headers: { Authorization: `Bearer ${token}` },
            });

            let successMessage = response.data.message ? response.data.message : response.message;
            toastr.success(successMessage);
            dispatch(getInterviewScheduleListAPI(advtId));
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const getInterviewScheduleListAPI = (advId) => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        let advid = advId ? advId : '';
        try {
            response = await API.get(INTERVIEW_SCHEDULE_API_ENDPOINT + `?advid=${advid}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: GET_INTERVIEW_SCHEDULE_LIST,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
};

export const updateInterviewScheduleAPI = (advtId, requestData) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.patch(INTERVIEW_SCHEDULE_API_ENDPOINT, requestData, {
                headers: { Authorization: `Bearer ${token}` },
            });

            let successMessage = response.data.message ? response.data.message : response.message;
            toastr.success(successMessage);
            dispatch(getInterviewScheduleListAPI(advtId));
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
}

export const getEligibleCandidatesSampleFileAPI = () => {
    return async () => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        const token = session.jwtResponse && session.jwtResponse.token;

        let response;
        try {
            response = await API.get(GET_ELIGIBLE_CANDIDATES_SAMPLE_FILE,
                {
                    headers: { 'Authorization': `Bearer ${token}` },
                    responseType: 'blob',
                }
            );
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                JSON.parse(await error.response.data.text()).message : error.message
            toastr.error(errorMessage);
            return;
        }
        FileDownload(response.data, `Eligible Candidates Sample File.csv`);
    }
};

export const uploadEligibleCandidatesCsvFileAPI = (data) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let formData = new FormData();
        if (data.file) {
            formData.append('file', data.file);
        };

        if (data.advertisementId) {
            formData.append('advertisementId', data.advertisementId);
        };

        if (data.postId) {
            formData.append('postId', data.postId);
        };
        if (data.shuffleAllRecords) {
            formData.append('shuffleAllRecords', data.shuffleAllRecords ? data.shuffleAllRecords : false);
        };

        let header = {
            'Authorization': `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
            "Accept": "application/json",
            "type": "formData",
        }
        let response;
        try {
            response = await API.post(UPLOAD_ELIGIBLE_CANDIDATES_FILE, formData, {
                headers: header,
            });
            if (response && response.data && response.data.errorInFile) {
                let errorMessage = (response.data && response.data.message) ? response.data.message : response.message;
                toastr.error(errorMessage);
                if (response && response.data && response.data.interviewPtCsvDtoList && response.data.interviewPtCsvDtoList.length > 0) {
                    const errors = response.data.interviewPtCsvDtoList.map((row) => ({
                        venue: row
                    }));
                    const csvData = examStaffDataJsonToCsv(errors);
                    examStaffDataDownloadFile(csvData, "Eligible Candidates Error File");
                }
            } else {
                let successMessage = (response.data && response.data.message) ? response.data.message : response.message;
                toastr.success(successMessage);
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const getInterviewReportDetailsAPI = () => {
    return async function (dispatch) {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let response;
        try {
            response = await API.get(GET_LOOKUP_OPTIONS_DATA + `?module=interview_pt` + `&type=report`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            dispatch({
                type: SET_INTERVIEW_REPORT_DATA,
                payload: response.data,
            });
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    };
};

export const downloadEligibleCandidatesListFileAPI = (advId, postId, reportType) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        const token = session.jwtResponse && session.jwtResponse.token;
        let advid = advId ? advId : '';
        let postid = postId ? postId : '';
        let schtypeid = reportType ? reportType : '';

        let response;
        try {
            response = await API.get(DOWNLOAD_ELIGIBLE_CANDIDATES_LIST_FILE + `?advid=${advid}` + `&postid=${postid}` + `&schtypeid=${schtypeid}`,
                {
                    headers: { 'Authorization': `Bearer ${token}` },
                }
            );
            if (response && response.data && response.data.eligibleCandidateListReportDto) {
                generatePdf(response.data.eligibleCandidateListReportDto)
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const downloadAttendanceMusterListFileAPI = (advId, postId, reportType, examCenterId, interviewCommitteeId, interviewReportDate, interviewSessionId, venueName, interviewPtLetterReportName) => {
    return async (dispatch) => {
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        const token = session.jwtResponse && session.jwtResponse.token;
        let advid = advId ? advId : '';
        let postid = postId ? postId : '';
        let schtypeid = reportType ? reportType : '';
        let examcenterid = examCenterId ? examCenterId : '';
        let date = interviewReportDate ? dayjs(interviewReportDate).format('DD-MM-YYYY') : "";
        let committee = interviewCommitteeId ? interviewCommitteeId : '';
        let sessionId = interviewSessionId ? interviewSessionId : '';
        let vfMusterflg = (interviewPtLetterReportName === "VERIFICATION MUSTER") ? true : false;

        let response;
        try {
            response = await API.get(DOWNLOAD_MUSTER_REPORT + `?advid=${advid}` + `&postid=${postid}` + `&schtypeid=${schtypeid}` + `&examcenterid=${examcenterid}` + `&date=${date}` + `&committee=${committee}` + `&session=${sessionId}` + `&vfmuster=${vfMusterflg}`,
                {
                    headers: { 'Authorization': `Bearer ${token}` },
                }
            );
            if (response && response.data) {
                const getFilteredMusterReportDto = (response, venueName) => {
                    if (response && response.data && response.data.musterReportDto && response.data.musterReportDto.length > 0) {
                        const filteredArray = response.data.musterReportDto.filter(e => e.venue === venueName);
                        return filteredArray.length > 0 ? filteredArray[0] : {};
                    }
                    return {};
                };

                const musterReportDto = getFilteredMusterReportDto(response, venueName);
                if (musterReportDto) {
                    generateMusterReportPdf(musterReportDto, interviewPtLetterReportName)
                }
            }
        } catch (error) {
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const getApplicationDetailsAPI = (applnid, postid) => {
    return async (dispatch) => {
        let response;
        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        try {
            response = await API.get(GET_APPLICATION_DETAILS_FOR_APPLICATION_PROFILE_REPORT + `?applnid=${applnid}` + `&postid=${postid}` + `&sumsheet=false`, { headers: { 'Authorization': `Bearer ${token}` } });
            if (response && response.data && response.data.application) {
                dispatch({
                    payload: response.data,
                    type: SET_APPLICATION_DETAILS_FOR_APPLICATION_PROFILE_REPORT
                })
            }
        } catch (error) {
            dispatch(hideLoader());
            let errorMessage = (error.response && error.response.data) ?
                error.response.data.message : error.message
            toastr.error(errorMessage);
            return;
        }
    }
};

export const getAllNameOfIndexingBodies = () => {
    return async (dispatch) => {
        dispatch(showLoader());
        let response = await API.get(GET_LOOKUP_OPTIONS_DATA, {
            params: {
                module: "profile_creation",
                type: "publication_indexing_bodies"
            }
        });
        if (response != null) {
            dispatch(hideLoader());
        }
        dispatch({
            payload: (response && response.data) ? response.data : [],
            type: GET_NAME_OF_INDEXING_BODIES
        });
    }
};

export const getAllPublicationArticleTypes = () => {
    return async (dispatch) => {
        dispatch(showLoader());
        let response = await API.get(GET_LOOKUP_OPTIONS_DATA, {
            params: {
                module: "profile_creation",
                type: "publication_article_type"
            }
        });
        if (response != null) {
            dispatch(hideLoader());
        }
        dispatch({
            payload: (response && response.data) ? response.data : [],
            type: GET_TYPE_OF_ARTICLES
        });
    }
};